import React from "react";
import ProcurementDetailsHeader from "./ProcurementDetailsHeader";
import { ProcurementComms } from "./ProcurementComms";
import { Col, Row, Space } from "antd";


const ProcLayout = ({ children,stage_data,isUserAllowed }) => {

  return (
    <>
      <Row gutter={[60, 12]} justify="center">
        <Col span={20}>
          <ProcurementDetailsHeader />
        </Col>
        <Col span={20}>
          <ProcurementComms isUserAllowed={isUserAllowed}/>
        </Col>
        <Col span={20}>
        {children}
        </Col>
      </Row>
    </>
  );
};

export default ProcLayout;
